import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { DevicesAppDataProviderFactory } from '../factory/DevicesAppDataProviderFactory';
import { DevicesAppBaseDataProvider } from '../dataProvider/DevicesAppBaseDataProvider';
import { DevicesAppWebComponentSchema } from '../types';

export class DevicesAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: DevicesAppDataProviderFactory;
  public dataProvider: DevicesAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new DevicesAppDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<DevicesAppWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
